import clsx from 'clsx'

export default function PlusMinus({
	isOpen,
	className,
	fill = '#0026B8',
}: {
	isOpen: boolean
	className?: string
	fill?: string
}) {
	return (
		<svg
			width="21"
			height="20"
			viewBox="0 0 21 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={clsx(className, 'shrink-0')}
		>
			<rect
				x="9.5"
				width="2"
				height="20"
				fill={fill}
				className={`transition-transform duration-[250ms] ease-in-out origin-top ${isOpen ? 'translate-y-6' : ''}`}
			/>
			<rect x="20.5" y="9" width="2" height="20" transform="rotate(90 20.5 9)" fill={fill} />
		</svg>
	)
}
